import { Button } from "antd";
import styled, { keyframes } from "styled-components";

const slideUpFade = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    cursor: pointer;
    color: #8c8c8c;

    &:hover {
      color: #000;
    }
  }
`;

export const PopoverContent = styled.div`
  width: 360px;
  max-height: 420px;
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1100;

  background: #ffffff;
  border-radius: 8px;
  padding: 16px;

  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.08),
    0 3px 6px rgba(0, 0, 0, 0.12);

  display: flex;
  flex-direction: column;
  overflow-y: auto;

  animation: ${slideUpFade} 0.25s ease-out;
  will-change: opacity, transform;

  @media (min-width: 1540px) {
    width: 400px;
    max-height: 600px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 12px;

  svg {
    cursor: pointer;
    color: #8c8c8c;

    &:hover {
      color: #000;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
`;

export const Container = styled.div<{ $visualizada: boolean }>`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 12px;
  background: ${({ $visualizada }) => ($visualizada ? "#ffffff" : "#f9fafb")};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.token.colorPrimary};
  line-height: 1.3;
`;

export const Description = styled.div`
  font-size: 14px;
  color: #595959;
  line-height: 1.4;
`;

export const Image = styled.img`
  width: 100%;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
`;

export const ImageFallback = styled.div`
  width: 100%;
  height: 72px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: repeating-linear-gradient(
    -45deg,
    #f7f7f7,
    #f7f7f7 8px,
    #efefef 8px,
    #efefef 16px
  );
`;

export const ActionLink = styled.a`
  display: inline-block;
  font-size: 14px;
  color: #1890ff;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.token.colorPrimary};
  }
`;

export const AcceptButton = styled(Button)`
  margin-left: auto;

  && {
    width: fit-content;
    background-color: ${({ theme }) => theme.token.colorPrimary};
    border-color: ${({ theme }) => theme.token.colorPrimary};
    color: #fff;
  }

  &&:hover,
  &&:focus {
    background-color: ${({ theme }) => theme.token.colorPrimary};
    border-color: ${({ theme }) => theme.token.colorPrimary};
    color: #fff;
  }

  &&[disabled],
  &&[disabled]:hover,
  &&[disabled]:focus {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: #bfbfbf;
  }
`;

export const Date = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  align-self: flex-end;
`;
